import { FC } from "react";
import WishlistHeartIcon from "@/assets/svgExports/WishlistHeartIcon";
import { useSelector } from "react-redux";
import { RootState } from "@/redux/reducers";
import { WISHLIST_FEATURE_STATUS } from "@/constants/wishlist";
import { useFeatureLocks } from "src/hooks/useFeatureLocks";

type WishlistHeaderMenuItemProps = {
    color?: string;
    iconPosition?: "left" | "right";
    iconSize?: number,
    showComponent?: "icon" | "text" | "both";
    customTextClassName?: string;
    wrapperClassName?: string;
    ctaText?: string;
    isActive?: boolean;
    onClick?: () => void;
};

const WishlistIcon: FC<{ color?: string; height?: number; width?: number, iconSize?: number, isActive?: boolean }> = ({
    color,
    iconSize,
    isActive,
}) => (
    <WishlistHeartIcon color={color} iconSize={iconSize} isActive={isActive}/>
);

const WishlistText: FC<{ customTextClassName?: string, ctaText?: string }> = ({ customTextClassName = "", ctaText="Wishlist" }) => (
    <span className={`tw-font-inter tw-text-[17px] tw-font-normal ${customTextClassName}`}>
        {ctaText}
    </span>
);

const WishlistBoth: FC<{
    color?: string;
    iconPosition: "left" | "right";
    iconSize: number;
    wrapperClassName: string;
    customTextClassName?: string;
    ctaText?: string;
    isActive?: boolean;
}> = ({ color, iconPosition, iconSize, wrapperClassName, customTextClassName = "", ctaText, isActive }) => (
    <div className={`tw-flex tw-gap-[10px] tw-items-center ${wrapperClassName}`}>
        {iconPosition === "right" ? (
            <>
                <WishlistText customTextClassName={customTextClassName} ctaText={ctaText}/>
                <WishlistIcon color={color} iconSize={iconSize} isActive={isActive}/>
            </>
        ) : (
            <>
                <WishlistIcon color={color} iconSize={iconSize} isActive={isActive}/>
                <WishlistText customTextClassName={customTextClassName} ctaText={ctaText}/>
            </>
        )}
    </div>
);

const WishlistHeaderMenuItem: FC<WishlistHeaderMenuItemProps> = ({
    color,
    iconSize,
    iconPosition = "right",
    showComponent = "both",
    customTextClassName = "",
    wrapperClassName = "",
    ctaText,
    isActive,
    onClick,
}) => {

    const {wishlistFeatureActive} = useSelector((state: RootState) => ({
        wishlistFeatureActive: state.storeReducer?.store?.services?.wishlist_flag,
    }));

    const { wishlistFeatureStatus } = useFeatureLocks();

    if (wishlistFeatureActive !== WISHLIST_FEATURE_STATUS.WISHLIST_ACTIVE || wishlistFeatureStatus?.isLocked) {
        return null;
    }

    if (showComponent === "icon")
        return <span onClick={onClick} style={{ cursor: onClick ? "pointer" : undefined }}>
            <WishlistIcon color={color} iconSize={iconSize} isActive={isActive}/>
        </span>;
    if (showComponent === "text")
        return <span onClick={onClick} style={{ cursor: onClick ? "pointer" : undefined }}>
            <WishlistText customTextClassName={customTextClassName} ctaText={ctaText}/>
        </span>;
    return (
        <div onClick={onClick} style={{ cursor: onClick ? "pointer" : undefined }}>
            <WishlistBoth
                color={color}
                iconPosition={iconPosition}
                iconSize={iconSize}
                wrapperClassName={wrapperClassName}
                customTextClassName={customTextClassName}
                ctaText={ctaText}
                isActive={isActive}
            />
        </div>
    );
};

export default WishlistHeaderMenuItem;
